import { IUser } from '@apps/Users/@services/users.service';

import { IHikingListItemDTO } from '../@types/DTO/hikingList.dto.types';
import { IHikingListItem } from '../@types/hikingList.types';

export const mapBackendHikingListItem = (backData: IHikingListItemDTO): IHikingListItem => {
  return {
    id: +backData.id,
    name: backData.name,
    ava: backData.ava,
    description: backData.desc,
    slogan: backData.slogan,
    idRoute: +backData.id_route,
    dateStart: new Date(backData.start_date),
    dateFinish: new Date(backData.finish_date),
    type: {
      id: +backData.id_type,
      name: backData.type,
    },
    duration: backData.duration,
    membersCount: +backData.members_count,
    isIMember: backData.member === '1',
    isIAdmin: backData.admin === '1',
    isIAuthor: backData.iauthor === '1',
    distance: +backData.distance,
    plannedDistance: +backData.plan_distance,
    members: backData.members_list.split('§').map((x) => {
      const [id, name, surname, photo] = x.split('¶');
      return { id: +id, name, surname, photo } satisfies IUser;
    }),
  };
};
